import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UseArtistPlaylistAppearancesProps {
  artistId: string;
  date?: Date;
}

export const useArtistPlaylistAppearances = ({ artistId, date }: UseArtistPlaylistAppearancesProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();

  const playlistAppearancesQuery = useTRPCQuery(
    trpcMusicAPI.artists.playlistAppearances.queryOptions({
      artistId,
      date,
      // Public share links pin the global view.
      countryCode: shareTokenInput.shareToken !== undefined ? undefined : countryCode,
      ...shareTokenInput,
    })
  );

  return playlistAppearancesQuery;
};
